module.exports = __webpack_public_path__ + "5870d1551799c8ae0492cebeb09699ad.svg";